import DespesaUsuario from './DespesaUsuario';

export default DespesaUsuario;